// extracted by mini-css-extract-plugin
module.exports = {"block":"NetlinkingBlocks_block__fvH06"};